import api from './api'

export type PortalPjFeedback = {
  id: string
  conteudo: string
  liberadoEm: string
  authorName: string
}

export const portalPjFeedbackService = {
  async listMine() {
    const { data } = await api.get<{ data: PortalPjFeedback[] }>('/pj-feedback/me')
    return data.data
  },
}
